import { render, staticRenderFns } from "./BeforeLogin.vue?vue&type=template&id=4ec3d448&scoped=true"
import script from "./BeforeLogin.vue?vue&type=script&lang=js"
export * from "./BeforeLogin.vue?vue&type=script&lang=js"
import style0 from "./BeforeLogin.vue?vue&type=style&index=0&id=4ec3d448&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec3d448",
  null
  
)

export default component.exports